import React, { Component, Fragment } from "react";
import {
  Card,
  Row,
  Col,
  Button,
  Input,
  ButtonGroup,
  Alert as Alert2,
  CardHeader,
  CardBody,
  CardDeck,
  Label,
  Spinner
} from "reactstrap";
import { api, dateHelper } from "../helpers";
import Alert from "react-s-alert";
import "./Site.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Dropzone from "react-dropzone";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { constant } from "../helpers";
import Select from "react-select";
import Switch from "react-switch";

const uploadUrl = uploadType => {
  switch (uploadType) {
    case constant.uploadType.shipping:
      return "Upload/UploadShippingData";
    case constant.uploadType.production:
      return "Upload/UploadProductionData";
    case constant.uploadType.product:
      return "Upload/UploadProducts";
    case constant.uploadType.productionHistorical:
      return "Upload/UploadProductionHistory";
    case constant.uploadType.shippingHistorical:
      return "Upload/UploadShippingHistory";
    case constant.uploadType.part:
      return "Upload/UploadPartsList";
    case constant.uploadType.inventory:
      return "Upload/UploadInventory";
    default:
      throw new Error("Upload type not recognized");
  }
};

export default class UploadPanel extends Component {
  constructor(props) {
    super(props);

    const isShippingUpload = props.uploadType === constant.uploadType.shipping;

    this.state = {
      message: null,
      dateMessage: null,
      messageColor: null,
      isMessageVisible: false,
      isDateMessage: true,
      importProcessing: false,
      uploadResults: null,
      importDate: isShippingUpload ? dateHelper.setDefaultShippingDate() : null,
      uploadType: props.uploadType,
      showShippingUploadType: false, //isShippingUpload,
      showDate: true,
      mimeType: isShippingUpload
        ? ".csv"
        : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      mimeTypeWarning: isShippingUpload
        ? "Please upload a .csv file"
        : "Please upload a spreadsheet in .xlsx format",
      shippingTypeList: constant.SHIPPING_TYPE_LIST.slice(),
      selectedShippingType: null,
      isBulk: false,
      jobId: null
    };
    this.onDismiss = this.onDismiss.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.onSelectChange = this.onSelectChange.bind(this);
    this.onSwitchChange = this.onSwitchChange.bind(this);
    this.checkJobStatus = this.checkJobStatus.bind(this);
  }

  componentDidMount() {
    let dateMessage = "";
    let messageColor = "";
    let isMessageVisible = true;
    let showDate = true;
    let showShippingUploadType = false
    let jobId = localStorage.getItem("UploadJobId") || null;
    // console.log("PREVIOUS JOB ID: ", jobId)
    switch (this.props.uploadType) {
      case constant.uploadType.shipping:
        isMessageVisible = false;
        showDate = false;
        showShippingUploadType = true;
        break;
      case constant.uploadType.production:
        dateMessage = "Select a date to OVERRIDE import file dates";
        messageColor = "info";
        showShippingUploadType = false;
        break;
      case constant.uploadType.product:
      case constant.uploadType.productionHistorical:
      case constant.uploadType.shippingHistorical:
        isMessageVisible = false;
        showDate = false;
        showShippingUploadType = false;
        break;
      default:
        break;
    }

    this.setState({
      dateMessage: dateMessage,
      messageColor: messageColor,
      isMessageVisible: isMessageVisible,
      showDate: showDate,
      showShippingUploadType: showShippingUploadType,
      jobId: jobId
    }, ()=>{
      // console.log(this.state.jobId, " STATE job id");
      this.checkJobStatus();
    });
  }

  checkJobStatus(){
    if (!this.state.jobId) return;
    // console.log("CHECK JOB STATS -JOB ID: ", this.state.jobId)
    api.post("Upload/CheckJobProgress/" + Number(this.state.jobId))
    .then(res => {
      if(res && res.data){
        switch (res.data)
        {
            case "Succeeded":
                localStorage.removeItem("UploadJobId");
                return Alert.success("Import Completed.");
            case "Enqueued":
            case "Processing":        
            default:
              return Alert.warning("Import is being processed...");
        }
      }
    }).catch(error => console.log(`There was an error checking job status for JobId: ${this.state.jobId}. Error: ${error}`));
  }

  onDismiss() {
    this.setState({
      isMessageVisible: !this.state.isMessageVisible,
      message: null,
      messageColor: null,
      dateMessage: null
    });
  }

  onDateChange(e) {
    this.setState({
      importDate: e
    });
  }

  onSelectChange(e){
    this.setState({
      selectedShippingType: e
    })
  }

  onSwitchChange(checked) {
    this.setState({isBulk: checked});
  }

  render() {
    console.log("Shipping Stuff ", this.state.showShippingUploadType)
    return (
      <Card>
        <CardHeader className="pageTitle p-2">
          <h5>{this.props.uploadType} Upload</h5>
        </CardHeader>
        <CardBody>
          <Row className="p-2 mt-2 float-right">
            {this.props.onCancel && (
              <ButtonGroup className="float-right">
                <Button
                  size="sm"
                  className="cbdmdSecondary"
                  onClick={this.props.onCancel}
                >
                  <FontAwesomeIcon icon="reply" title="Hide" />
                </Button>
              </ButtonGroup>
            )}
          </Row>
          <CardDeck>
            <Card>
              {this.state.dateMessage && (
                <Alert2 color="warning">{this.state.dateMessage}</Alert2>
              )}

              {this.state.showDate && (
                <Row className="p-2 mt-2">
                  <Col>
                    <Label className="mr-2">Import Date: </Label>
                    <DatePicker
                      selected={this.state.importDate}
                      onChange={this.onDateChange}
                      className="form-control"
                      maxDate={new Date()}
                    />
                  </Col>
                </Row>
              )}

              {this.state.showShippingUploadType && (
                <Fragment>
                  <Row className="p-2 mt-2">
                    <Col>
                      <Label className="mr-2">Shipping Type: </Label>
                      <Select
                        options={this.state.shippingTypeList}
                        value={this.state.selectedShippingType || null}
                        onChange={(e) => this.onSelectChange(e)}
                      />
                    </Col>
                    {this.state.selectedShippingType 
                      && this.state.selectedShippingType.value === constant.SHIPPING_TYPES.Acumatica.value
                      && 
                      <Col>
                        <Label className="mr-2">
                          Is Bulk Upload?: 
                        </Label>
                        <div>
                          <Switch 
                            onChange={(checked) => this.onSwitchChange(checked)}
                            checked={this.state.isBulk}
                          />
                        </div>
                      </Col>
                    }
                  </Row>
                    {this.state.isBulk &&
                        <Row>
                        <Col>                          
                            <div className="p-2">
                              <Alert2 color={"info"}>
                                <span>Use this option for large Acumatica shipping data upload. This option will allow the upload to run in the background allowing you to navigate to other screens. </span>
                              </Alert2>
                            </div>                          
                        </Col>
                        </Row>
                        }                 
                </Fragment>
              )}

              <Row className="p-2 mt-2">
                <Col>
                  <Dropzone
                    accept={this.state.mimeType}
                    onDrop={acceptedFiles => {
                      if (
                        !acceptedFiles ||
                        !acceptedFiles.length ||
                        acceptedFiles.length < 0
                      ) {
                        Alert.warning(this.state.mimeTypeWarning);
                        return;
                      }
                      if(this.state.isShippingUpload && (!this.state.selectedShippingType || this.state.selectedShippingType === null)){
                        Alert.warning("Shipping type is required. Please select a shipping type.");
                        return;
                      }
                      this.setState({
                        importProcessing: true
                      });
                      const formData = new FormData();
                      formData.append("file", acceptedFiles[0]);
                      var overrideDate =
                        this.state.importDate === null ? false : true;
                      var date =
                        this.state.importDate === null
                          ? dateHelper.formatDateForServer(new Date())
                          : dateHelper.formatDateForServer(
                              this.state.importDate
                            );
                      formData.append("date", date);
                      formData.append("overrideDate", overrideDate);
                      if(this.state.selectedShippingType){
                        formData.append("typeOfShipping", this.state.selectedShippingType.value);
                        formData.append("isBulk", this.state.isBulk);
                      }
                      api
                        .postFormData(
                          uploadUrl(this.props.uploadType),
                          formData
                        )
                        .then(response => {
                          if (response.data) {
                            if(response.data.jobId && response.data.jobId.length){
                              localStorage.setItem("UploadJobId", response.data.jobId);
                            }
                            var message =
                              (response.data.items.length ||
                                response.data.successfulRecordCount > 0) &&
                              response.data.failedRecordCount === 0
                                ? 
                                  this.state.isBulk
                                    ? `${this.props.uploadType} upload is in progress...`
                                    : `${this.props.uploadType} upload complete!`
                                : `${
                                    this.props.uploadType
                                  } upload completed with errors.`;
                            var messageColor =
                              response.data.failedRecordCount > 0
                                ? "warning"
                                : response.data.items.length ||
                                  response.data.successfulRecordCount > 0
                                  ? "success"
                                  : "danger";
                            this.setState(
                              {
                                uploadResults: response.data,
                                message: message,
                                messageColor: messageColor,
                                isMessageVisible: true,
                                importProcessing: false
                              },
                              () => {
                                if (response.data.successfulRecordCount > 0) {
                                  var filterDate =
                                    this.state.importDate !== null
                                      ? this.state.importDate
                                      : new Date(); //dateHelper.getUtcDate();
                                  this.props.onSuccess(filterDate);
                                }
                              }
                            );
                          } else {
                            Alert.error(
                              "An error occurred while processing upload."
                            );
                            this.setState({
                              importProcessing: false,
                              uploadResults: null
                            });
                          }
                        })
                        .catch(error => {
                          Alert.error(
                            "There was an error processing the import data."
                          );
                          this.setState({
                            importProcessing: false
                          });
                        });
                    }}
                  >
                    {({ getRootProps, getInputProps }) => (
                      <section>
                        <div
                          {...getRootProps()}
                          style={{
                            backgroundColor: "#f5f5f5",
                            border: "dashed 1px #000000",
                            padding: "3em",
                            borderRadius: "5px"
                          }}
                        >
                          <input {...getInputProps()} />
                          <h5>
                            {`Drag ${
                              this.props.uploadType
                            } Spreadsheet here to upload (or click here to
                            choose file)`}
                          </h5>
                        </div>
                      </section>
                    )}
                  </Dropzone>
                </Col>
              </Row>
            </Card>

            <Card>
              <CardBody>
                <h6>
                  Upload{" "}
                  {this.state.importProcessing ? "processing ..." : "Details"}
                </h6>
                {this.state.message ? (
                  <Alert2
                    color={this.state.messageColor}
                    toggle={() => this.onDismiss()}
                  >
                    {this.state.message}
                  </Alert2>
                ) : null}
                {this.state.uploadResults ? (
                  <div>
                    <Row>
                      <Col>
                        <Label>
                          Total Products
                          <Input
                            type="text"
                            value={this.state.uploadResults.totalRecordCount}
                            disabled={true}
                          />
                        </Label>
                      </Col>
                      <Col>
                        <Label>
                          Total Failed
                          <Input
                            type="text"
                            value={this.state.uploadResults.failedRecordCount}
                            disabled={true}
                          />
                        </Label>
                      </Col>
                      <Col>
                        <Label>
                          Total Successful Imports
                          <Input
                            type="text"
                            value={
                              this.state.uploadResults.successfulRecordCount
                            }
                            disabled={true}
                          />
                        </Label>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Label>Message(s)</Label>
                        <Input
                          type="textarea"
                          style={{ height: "130px" }}
                          value={
                            this.state.uploadResults.message ||
                            "Nothing to report"
                          }
                          disabled={true}
                        />
                      </Col>
                    </Row>
                  </div>
                ) : (
                  <div>
                    <Row className="centerText">
                      <Col className="centerText mt-3">
                        {this.state.importProcessing ? (
                          <Spinner style={{ width: "3rem", height: "3rem" }} />
                        ) : (
                          <span className="detailText">Nothing to process</span>
                        )}
                      </Col>
                    </Row>
                  </div>
                )}
              </CardBody>
            </Card>
          </CardDeck>
        </CardBody>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/UploadPanel.js